// @ts-nocheck
import { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import Button from 'js/components/Button'
import Flexer from 'js/components/Flexer/Flexer'
import { H4 } from 'js/components/Heading'
import Img from 'js/components/Img/Img'
import { InsertImageModal } from 'js/components/InsertMediaModal'
import Spacer from 'js/components/Spacer/Spacer'

const IconField = ({ iconProps, ...rest }) => {
    const { t } = useTranslation()
    const { watch, setValue } = useFormContext()

    const icon = watch('icon')
    const iconUrl = icon?.download

    const [showImageModal, setShowImageModal] = useState(false)
    const toggleShowImageModal = () => {
        setShowImageModal(!showImageModal)
    }

    const setImage = (val) => {
        setValue('icon', val)
    }

    const removeImage = () => {
        setValue('icon', null)
    }

    return (
        <div {...rest}>
            <H4 style={{ marginBottom: '4px' }}>{t('form.icon')}</H4>
            <Spacer spacing="small">
                {icon && <Img src={iconUrl} {...iconProps} />}

                <Flexer gutterSize="md" justifyContent="flex-start">
                    <Button
                        size="small"
                        variant="secondary"
                        onClick={toggleShowImageModal}
                    >
                        {icon
                            ? t('action.change-image')
                            : t('action.insert-image')}
                        ..
                    </Button>
                    {icon && (
                        <Button
                            size="small"
                            variant="secondary"
                            onClick={removeImage}
                        >
                            {t('form.remove-image')}
                        </Button>
                    )}
                </Flexer>

                <InsertImageModal
                    showModal={showImageModal}
                    setShowModal={setShowImageModal}
                    image={icon}
                    onComplete={({ file }) => {
                        setImage(file)
                    }}
                />
            </Spacer>
        </div>
    )
}

export default IconField
